import React from 'react';
import moment from 'moment';
import { Button } from 'react-bootstrap';

/** Core */
import { Table, THead, TBody, Row, Cell } from '../../../core/Table';

/** Styles */
import { StyledTableControl, StyledAvatarPerson } from './style';

import { AVATAR_MEDIUM } from '../../../../utils/crops';

const SearchTableControl = ({
  className,
  dataSearchAccess,
  currentPage,
  goToPreviousPage,
  goToNextPage
}) => {
  const formatHours = date => moment.utc(date).format('HH:mm:ss');

  return (
    <StyledTableControl className={className}>
      <Table summary="Busqueda de control de accesos">
        <THead>
          <Row>
            <Cell />
            <Cell tagName="th" scope="col" className="th-name">
              Nombre
            </Cell>
            <Cell tagName="th" scope="col" className="th-name">
              Apellidos
            </Cell>
            <Cell tagName="th" scope="col" className="th-date">
              Fecha
            </Cell>
            <Cell tagName="th" scope="col" className="th-time">
              Hora entrada
            </Cell>
            <Cell tagName="th" scope="col" className="th-time">
              Hora salida 1
            </Cell>
            <Cell tagName="th" scope="col" className="th-time">
              Hora vuelta 1
            </Cell>
            <Cell tagName="th" scope="col" className="th-time">
              Hora salida 2
            </Cell>
            <Cell tagName="th" scope="col" className="th-time">
              Hora vuelta 2
            </Cell>
            <Cell tagName="th" scope="col" className="th-time">
              Hora salida 3
            </Cell>
            <Cell tagName="th" scope="col" className="th-time">
              Hora vuelta 3
            </Cell>
            <Cell tagName="th" scope="col" className="th-time">
              Hora salida 4
            </Cell>
            <Cell tagName="th" scope="col" className="th-time">
              Hora vuelta 4
            </Cell>
            <Cell tagName="th" scope="col" className="th-time">
              Hora salida
            </Cell>
            <Cell tagName="th" scope="col" className="th-observations">
              Observaciones
            </Cell>
          </Row>
        </THead>
        <TBody>
          {dataSearchAccess && dataSearchAccess.length > 0 ? (
            dataSearchAccess.map((item, i) => (
              <Row key={`row_${i + 1}`}>
                <Cell>
                  <StyledAvatarPerson
                    name={item.name}
                    lastname={item.lastname}
                    userId={String(item.userId)}
                    crop={AVATAR_MEDIUM}
                    avatarPhoto={item.avatarPhoto}
                  />
                </Cell>
                <Cell>{item.name}</Cell>
                <Cell>{item.lastname}</Cell>
                <Cell>{moment(item.date).format('DD/MM/YYYY')}</Cell>
                <Cell>
                  <strong>
                    {item.accessTime ? formatHours(item.accessTime) : '--'}
                  </strong>
                </Cell>
                <Cell>
                  <strong>
                    {item.startBreakTime
                      ? formatHours(item.startBreakTime)
                      : '--'}
                  </strong>
                </Cell>
                <Cell>
                  <strong>
                    {item.endBreakTime ? formatHours(item.endBreakTime) : '--'}
                  </strong>
                </Cell>
                <Cell>
                  <strong>
                    {item.startBreakTime2
                      ? formatHours(item.startBreakTime2)
                      : '--'}
                  </strong>
                </Cell>
                <Cell>
                  <strong>
                    {item.endBreakTime2
                      ? formatHours(item.endBreakTime2)
                      : '--'}
                  </strong>
                </Cell>
                <Cell>
                  <strong>
                    {item.startBreakTime3
                      ? formatHours(item.startBreakTime3)
                      : '--'}
                  </strong>
                </Cell>
                <Cell>
                  <strong>
                    {item.endBreakTime3
                      ? formatHours(item.endBreakTime3)
                      : '--'}
                  </strong>
                </Cell>
                <Cell>
                  <strong>
                    {item.startBreakTime4
                      ? formatHours(item.startBreakTime4)
                      : '--'}
                  </strong>
                </Cell>
                <Cell>
                  <strong>
                    {item.endBreakTime4
                      ? formatHours(item.endBreakTime4)
                      : '--'}
                  </strong>
                </Cell>
                <Cell>
                  <strong>
                    {item.exitTime ? formatHours(item.exitTime) : '--'}
                  </strong>
                </Cell>
                <Cell>{item.comment}</Cell>
              </Row>
            ))
          ) : (
            <Row>
              <Cell colSpan="9">No hay datos disponibles</Cell>
            </Row>
          )}
        </TBody>
      </Table>
      <Button onClick={goToPreviousPage} disabled={currentPage === 0} hidden>
        Anterior
      </Button>
      <Button
        onClick={goToNextPage}
        disabled={dataSearchAccess.length === 0}
        hidden
      >
        Siguiente
      </Button>
    </StyledTableControl>
  );
};

export default SearchTableControl;
